import React, { ReactNode, useState } from 'react'
import { StyleProp, StyleSheet, View, ViewStyle } from 'react-native'

interface GestureTouchableOpacityProps {
  onPress?: () => void
  style?: StyleProp<ViewStyle>
  activeOpacity?: number
  disabled?: boolean
  testID?: string
  children?: ReactNode
}

/**
 * Pressable icon wrapper that renders what react-native-gesture-handler's
 * TouchableOpacity rendered on the web: an outer `role="button"` element and
 * an inner focusable element carrying `style` and the press opacity.
 */
export default function GestureTouchableOpacity({
  onPress,
  style,
  activeOpacity = 0.2,
  disabled,
  testID,
  children
}: GestureTouchableOpacityProps) {
  const [pressed, setPressed] = useState(false)
  const release = () => setPressed(false)

  return (
    <View
      accessibilityRole="button"
      testID={testID}
      style={styles.button}
      // @ts-ignore react-native-web forwards DOM mouse events
      onMouseDown={() => !disabled && setPressed(true)}
      onMouseUp={release}
      onMouseLeave={release}
      onClick={disabled ? undefined : () => onPress?.()}
    >
      <View
        accessible
        style={[style, { opacity: pressed ? activeOpacity : 1 }]}
      >
        {children}
      </View>
    </View>
  )
}

const styles = StyleSheet.create({
  button: {
    userSelect: 'none'
  } as ViewStyle
})
